<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  name: "ActivityApp",
  methods: {},
};
</script>
<style>
body.no-scroll {
  height: 100%;
  overflow: hidden;
}
</style>
